import { useLanguage } from '../i18n/LanguageContext';

// Utility function to format numbers with language-specific thousands separator
export const formatPrice = (price: number, language: 'en' | 'is'): string => {
  const separator = language === 'en' ? ',' : '.';

  // Convert number to string and add thousands separator
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

// Hook to get the formatter function with current language
export const useNumberFormatter = () => {
  const { language } = useLanguage();

  return {
    formatPrice: (price: number) => formatPrice(price, language),
    formatNumber: (num: number) => formatPrice(num, language),
  };
};

// Utility function to get localized name based on language
export const getLocalizedName = (
  item: { name: string; name_is?: string | null },
  language: 'en' | 'is'
): string => {
  if (language === 'is' && item.name_is) {
    return item.name_is;
  }
  return item.name;
};

// Utility function to get localized description based on language
export const getLocalizedDescription = (
  item: { description: string; description_is?: string | null },
  language: 'en' | 'is'
): string => {
  if (language === 'is' && item.description_is) {
    return item.description_is;
  }
  return item.description;
};

// Hook to get localized name function with current language
export const useLocalizedName = () => {
  const { language } = useLanguage();

  return (item: { name: string; name_is?: string | null }) => getLocalizedName(item, language);
};

// Hook to get localized description function with current language
export const useLocalizedDescription = () => {
  const { language } = useLanguage();

  return (item: { description: string; description_is?: string | null }) =>
    getLocalizedDescription(item, language);
};
